import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { warningAlertConfirmInsert, warningAlertConfirmDelete } from 'redux/action/warningAlert';
import { IoMdEyeOff, IoMdEye } from 'react-icons/io';
import { ModuleSimpleInfoContainer } from './ModuleSimpleInfo.css';

import { TiBatteryCharge, TiBatteryHigh, TiBatteryMid, TiBatteryLow } from 'react-icons/ti';
import { moduleScnMap } from 'utils/code';

const ModuleSimpleInfo = ( props ) => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  
  useEffect(() => () => cancellationToken.cancel(), []);

  const onClickAlertConfirm = useCallback((idx) => {
    if (props.alertConfirm) {
      dispatch(warningAlertConfirmInsert({idx: idx}));
    }
    else {
      dispatch(warningAlertConfirmDelete({idx: idx}));
    }
  }, [props.alertConfirm])
  
  return (
    <ModuleSimpleInfoContainer>
      <div>
        {moduleScnMap[props.moduleScn].viewTitle}
      </div>
      <div>
        {props.modelNm}
      </div>
      <div onClick={() => {onClickAlertConfirm(props.moduleIdx)}}>
        {
          props.alertConfirm ? <IoMdEye /> : <IoMdEyeOff />
        }
      </div>
      <div>
        {props.battery >= 75 && <TiBatteryCharge />}
        {props.battery < 75 && props.battery >= 50 && <TiBatteryHigh />}
        {props.battery < 50 && props.battery >= 20 && <TiBatteryMid />}
        {props.battery < 20 && <TiBatteryLow style={{color: '#ff0000'}} />}
      </div>
    </ModuleSimpleInfoContainer>
  )
}

export default ModuleSimpleInfo;